/**
 * Banner 4 — Full-bleed hero with centered headline + feature grid (icon / title / body).
 * metadata = feature rows; metadata_1 = background (desktop + optional mobile).
 */

export const BANNER_5_DEFAULT_FEATURE_ROWS = [
  {
    id: "1",
    icon: "",
    alt_icon: "Live sessions",
    title: "100% Live, Faculty-Led Sessions",
    description:
      "Delivered through 100 percent live instruction. 96 hours of live weekend classes by IIT Kgp faculty.",
    priority: 1,
    status: true,
  },
  {
    id: "2",
    icon: "",
    alt_icon: "Faculty",
    title: "Faculty Leadership",
    description:
      "Taught exclusively by professors from the Department of Computer Science and Engineering, IIT Kharagpur.",
    priority: 2,
    status: true,
  },
  {
    id: "3",
    icon: "",
    alt_icon: "Academic rigour",
    title: "Academic Rigour",
    description:
      "Research-backed instruction with strong theoretical grounding and applied relevance.",
    priority: 3,
    status: true,
  },
  {
    id: "4",
    icon: "",
    alt_icon: "Curriculum",
    title: "Curriculum: The AI-Native Engineering Journey",
    description: "Frontend → Backend → AI Systems → Agents → Production",
    priority: 4,
    status: true,
  },
  {
    id: "5",
    icon: "",
    alt_icon: "Capstone",
    title: "One Integrated System + Capstone Project",
    description:
      "Build a single AI product across all modules (not demos) & deploy a live AI system.",
    priority: 5,
    status: true,
  },
  {
    id: "6",
    icon: "",
    alt_icon: "Alumni",
    title: "Executive Alumni Status & Award Ceremony",
    description:
      "Certificate presentation held on campus at IIT Kharagpur.",
    priority: 6,
    status: true,
  },
  {
    id: "7",
    icon: "",
    alt_icon: "Career support",
    title: "Career support & placement guidance",
    description:
      "Structured guidance on roles, portfolios, and interviews aligned with AI engineering careers.",
    priority: 7,
    status: true,
  },
];

export const BANNER_5_CONSTANTS = {
  METADATA_TITLES: {
    metadata: "Feature cards",
    metadata_1: "Background",
  },

  DEFAULT_ROW: {
    id: "1",
    icon: "",
    alt_icon: "Feature",
    title: "Feature title",
    description: "Short supporting copy for this highlight.",
    priority: 1,
    status: true,
  },

  DEFAULT_ROW_1: {
    id: "1",
    image: "",
    mobile_image: "",
    alt_image: "Hero background",
    mobile_alt_image: "Hero background mobile",
    priority: 1,
    status: true,
  },

  BANNER_FIELDS_CONFIG: [
    {
      fieldName: "hero_section_height",
      label: "Minimum section height on desktop (px, 0 = fit content)",
      value: 720,
      valueType: "number",
      filedType: "INPUT",
      placeholder: "720",
      defaultValue: 720,
    },
    {
      fieldName: "hero_container_max_width",
      label: "Content max width (px)",
      value: 1200,
      valueType: "number",
      filedType: "INPUT",
      placeholder: "1200",
      defaultValue: 1200,
    },
    {
      fieldName: "title_1",
      label:
        "Title (32px) — wrap text in { } to highlight it in the accent colour",
      value:
        "From Full Stack to AI-Native Systems, {led by IIT Kharagpur's Computer Science & Engineering Department}",
      valueType: "string",
      filedType: "INPUT",
      defaultValue:
        "From Full Stack to AI-Native Systems, {led by IIT Kharagpur's Computer Science & Engineering Department}",
    },
    {
      fieldName: "title_1_color",
      label: "Main headline colour",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      defaultValue: "#FFFFFF",
    },
    {
      fieldName: "subtitle_color",
      label: "Highlight & icon accent colour (text wrapped in { })",
      value: "#F5C451",
      valueType: "string",
      filedType: "COLOR",
      defaultValue: "#F5C451",
    },
    {
      fieldName: "gradient_color_1",
      label: "Overlay gradient — top (supports rgba)",
      value: "rgba(0, 0, 0, 0.55)",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "rgba(0,0,0,0.55)",
      defaultValue: "rgba(0, 0, 0, 0.55)",
    },
    {
      fieldName: "gradient_color_2",
      label: "Overlay gradient — bottom (supports rgba)",
      value: "rgba(0, 0, 0, 0.78)",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "rgba(0,0,0,0.78)",
      defaultValue: "rgba(0, 0, 0, 0.78)",
    },
    {
      fieldName: "background_color",
      label: "Fallback background (no image)",
      value: "#0a1628",
      valueType: "string",
      filedType: "COLOR",
      defaultValue: "#0a1628",
    },
    {
      fieldName: "status",
      label: "Banner status",
      value: true,
      valueType: "boolean",
      filedType: "TOGGLE",
      defaultValue: true,
    },
  ],

  METADATA_FIELDS: [
    {
      header: "Icon",
      fieldName: "icon",
      value: "",
      valueType: "string",
      filedType: "FILE",
      placeholder: "Upload icon (PNG/SVG)",
      defaultValue: "",
    },
    {
      header: "Icon alt",
      fieldName: "alt_icon",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      defaultValue: "",
    },
    {
      header: "Title",
      fieldName: "title",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      defaultValue: "",
    },
    {
      header: "Description",
      fieldName: "description",
      value: "",
      valueType: "string",
      filedType: "TEXT_AREA",
      defaultValue: "",
      rows: 3,
    },
    {
      header: "Priority",
      fieldName: "priority",
      value: 1,
      valueType: "number",
      filedType: "INPUT",
      defaultValue: 1,
    },
    {
      header: "Status",
      fieldName: "status",
      value: true,
      valueType: "boolean",
      filedType: "TOGGLE",
      defaultValue: true,
    },
  ],

  METADATA_FIELDS_1: [
    {
      header: "Desktop background",
      fieldName: "image",
      value: "",
      valueType: "string",
      filedType: "FILE",
      placeholder: "Full-bleed desktop image",
      defaultValue: "",
    },
    {
      header: "Mobile background (optional)",
      fieldName: "mobile_image",
      value: "",
      valueType: "string",
      filedType: "FILE",
      placeholder: "Uses desktop if empty",
      defaultValue: "",
    },
    {
      header: "Alt text (desktop)",
      fieldName: "alt_image",
      value: "Program hero background",
      valueType: "string",
      filedType: "INPUT",
      defaultValue: "Program hero background",
    },
    {
      header: "Alt text (mobile)",
      fieldName: "mobile_alt_image",
      value: "Program hero background mobile",
      valueType: "string",
      filedType: "INPUT",
      defaultValue: "Program hero background mobile",
    },
    {
      header: "Priority",
      fieldName: "priority",
      value: 1,
      valueType: "number",
      filedType: "INPUT",
      defaultValue: 1,
    },
    {
      header: "Status",
      fieldName: "status",
      value: true,
      valueType: "boolean",
      filedType: "TOGGLE",
      defaultValue: true,
    },
  ],
};
